import { SuiClient, getFullnodeUrl } from '@mysten/sui/client';
import { SUI_SYSTEM_STATE_OBJECT_ID } from '@mysten/sui/utils';

const network = import.meta.env.VITE_SUI_NETWORK || 'mainnet';
export const suiClient = new SuiClient({ url: getFullnodeUrl(network) });

export interface ActiveValidator {
    address: string;
    stake: bigint;
    name: string;
}

// Returns the active validator set from System State (0x5 obj).
export async function getActiveValidators(): Promise<ActiveValidator[]> {
    const system = await suiClient.getDynamicFieldObject({
        parentId: SUI_SYSTEM_STATE_OBJECT_ID,
        name: { type: "u64", value: "2" },
    });

    const fields = (system.data?.content! as Record<string, any>).fields.value.fields;

    const validators = fields.validators.fields.active_validators.map(
        (validator: any) => {
            return {
                address: validator.fields.metadata.fields.sui_address,
                stake: BigInt(validator.fields.staking_pool.fields.sui_balance.toString()),
                name: validator.fields.metadata.fields.name,
            };
        }
    ) as ActiveValidator[];

    return validators;
} 